import Mutations from '../../odata/mutations';

export default {
  ...new Mutations('reportExpenseLineItem'),
  ...new Mutations('reportExpenseLineItems'),
};
